/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AuthResponse {
    getFixupPrototypeFunction() { return AuthResponse.fixupPrototype; }

    static newInstance(model: Partial<AuthResponse>): AuthResponse {
        let obj = Object.assign(new AuthResponse(), model);
        AuthResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AuthResponse>): AuthResponse {
        if (!model) return null;
        return AuthResponse.newInstance(<AuthResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AuthResponse) {
        if (!obj) return;

        models.AuthResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AuthResponse): boolean {
        Object.setPrototypeOf(obj, AuthResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.token) {
            models.Authorization.fixupPrototype(this.token);
        }
        if (this.user) {
            models.UserModel.fixupPrototype(this.user);
        }
        if (this.audit) {
            models.AuditModel.fixupPrototype(this.audit);
        }
        if (this.tenants) {
            for (let val of this.tenants) {
                models.TokenTenantModel.fixupPrototype(val);
            }
        }
    }

    /**
     * This contains the atrributes access_token, expires_at & issued_at. access_token will be  passed with X-Auth-Token header in all other  APIs for authentication.
     */
    token: models.Authorization;

    /**
     * Header logo.
     */
    header_logo: string;

    /**
     * Banner logo.
     */
    banner_logo: string;

    /**
     * Contains information about the user associated with the Access Key / Secret Key.
     */
    user: models.UserModel;

    /**
     * Id of the Account in CoreStack. There can be multiple tenats within an account, so account_id will be required for performing account level actions such as createTenant.
     */
    account_id: string;

    /**
     * Implies the user associated with Access Key / Secret Key is an account admin in CoreStack. True means account admin.
     */
    is_account_admin: boolean;

    /**
     * List of tenants within the CoreStack account. Each tenant will have an id & name that uniquely identifies it.
     */
    tenants: Array<models.TokenTenantModel>;

    /**
     * Audit details
     */
    audit: models.AuditModel;

    /**
     * User Guide URL
     */
    user_guide_url: string;

    /**
     * Support URL
     */
    support_url: string;

    /**
     * Terms and Conditions URL
     */
    terms_and_conditions_url: string;

}
